import React from 'react';
import MultiSelectDropdown from './MultiSelectDropdown';
import { useDiscount } from 'contexts/DiscountContext';

const DiscountCategoryDropdown = ({ label = "Category", value, onChange, required = false, error = false, multiSelect = true }) => {
    const { getAllCategories } = useDiscount();

    const fetchCategories = async (searchValue, page) => {
        try {
            const response = await getAllCategories({ page, limit: 50, search: searchValue, activeOnly: true });
            return {
                options: response.categories.map((category) => ({
                    label: category.name,
                    value: category.id,
                })),
                hasMore: response.totalPages === 0 ? false : page !== response.totalPages,
            };
        } catch (error) {
            console.error('Error fetching category:', error);
            return { options: [], hasMore: false };
        }
    };

    return (
        <MultiSelectDropdown
            label={label}
            value={value}
            onChange={onChange}
            fetchData={fetchCategories}
            multiSelect={multiSelect}
            required={required}
            error={error}
        />
    );
};

export default DiscountCategoryDropdown;
